<template>
  <v-snackbar v-model="SnackBarComponent.SnackbarVmodel" :color="SnackBarComponent.SnackbarColor" location="top" :timeout="SnackBarComponent.SnackbarColor === 'error' ? 5000 : 1500">
    <div class="text-center">{{ SnackBarComponent.SnackbarText }}</div>
  </v-snackbar>
</template>
<script>
export default {
  props: {
    SnackBarComponent: Object,
  },
};
</script>
